import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { MembershipsList } from './memberships_list';
import { SingleMembership } from './single_membership';
const containerCss = "cdro2ww";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const textContainerCss = "tuu5o9q";
const TextContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textContainerCss, props.className)} />;
});
export const SlugConflictNotification = ({
  slug,
  memberships = []
}) => <Container>
    {memberships.length > 0 ? <>
          <p>{I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.line_1', {
        slug,
        count: memberships.length
      })}</p>
          {memberships.length > 1 ? <MembershipsList memberships={memberships} slug={slug} /> : <SingleMembership membership={memberships[0]} slug={slug} />}
          <p>{I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.line_2', {
        count: memberships.length
      })}</p>
        </> : <>
          <TextContainer>
            <BodyText>
              {HtmlParser(I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.general.line_1', {
          slug
        }))}
            </BodyText>
          </TextContainer>
          <TextContainer>
            <BodyText>{I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.general.line_2')}</BodyText>
          </TextContainer>
        </>}
  </Container>;

require("./slug_conflict_notification.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./slug_conflict_notification.js");